import React, { useEffect, useRef, useState } from 'react'
import styles from './DropDown.module.css'


const SingleSelect = (props:any) => {

    const [showOptions, setShowOptions] = useState(false)
    const [selected, setSelected] = useState(props.options[0])
    const dropDownRef = useRef<any>(null)

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
    }, [])

    const handleClickOutside = (event: any) => {
        if (dropDownRef && dropDownRef.current && !dropDownRef.current.contains(event.target)) {
            setShowOptions(false)
        }
    }

    const selectHandler = (event: any) => {
        const target = event.currentTarget;
        const selected = target.getAttribute('value');
        setSelected(selected)
        setShowOptions(false)
    }

    const toggleHandler = () => {
        setShowOptions(!showOptions)
    }

    const optionsList = props.options.map((option: string, i: number) => {
        return (
            <li key={i} className={option === selected ? 'active' : ''} value={option} onClick={selectHandler}>
                <label>
                    <span>{`${option}`}</span>
                </label>
            </li>
        )
    })

    return (
        <div className={`${styles.dropdownWrapper}  ${showOptions ? styles.active : styles.inactive}`} ref={dropDownRef}>
            <div className={styles.opted} onClick={() => toggleHandler()}>
                {selected ? `${selected}` : ''}
            </div>
            <ul className={`${styles.options} list-unstyled`}>
                {optionsList}
            </ul>
        </div>
    )
}

export default SingleSelect
